import styled from "@emotion/styled";

export const Calendar = styled.div`
  display: flex;
  align-items: center;
  margin: 0px auto;
  width: 124px;
`;
